/* eslint-disable max-len */
import * as React from 'react';
import { SVGProps } from 'react';

const SvgEducation = (props: SVGProps<SVGSVGElement>) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="24" cy="24" r="24" fill="url(#paint0_linear_education)" />
    <g transform="translate(9, 12) scale(0.66)" stroke="#F7F5F8" strokeWidth="1.97" strokeLinecap="round" strokeLinejoin="round" fill="none">
      <path d="M22.6466 10.7621L44.2099 10.7621V22.0692M35.3855 17.3103V29.0291C35.3855 30.229 34.7124 31.3211 33.6539 31.8544L32.8412 32.2544C26.4121 35.4485 18.8825 35.4485 12.4534 32.2544L11.6407 31.8544C10.5822 31.3211 9.90913 30.229 9.90913 29.0291V17.3103M1.13596 12.3144L21.5021 22.1697C22.2394 22.4901 23.0605 22.4901 23.7979 22.1697L44.164 12.3144C44.812 12.0306 44.812 11.0295 44.164 10.7456L23.7951 0.890354C23.0578 0.569882 22.2367 0.569882 21.4993 0.890354L1.13596 10.7487C0.488015 11.0325 0.488015 12.0336 1.13596 12.3175V12.3144Z" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_education" x1="0" y1="0" x2="41" y2="48" gradientUnits="userSpaceOnUse">
        <stop stopColor="#6DBE6D" />
        <stop offset="1" stopColor="#228B22" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgEducation;
